import { Reducer } from 'redux'
import { FlyoutMigrationProductsList } from './action'
import {
  FlyOutMigrationProducts,
  FlyOutMigrationProductsInfo,
} from '../../../types/addEditProduct'

export { ProductVisibility } from '../../../types/addEditProduct'

export type {
  MigrationProduct,
  MigrationProductsData,
  FlyOutMigrationProducts,
  FlyOutMigrationProductsInfo,
} from '../../../types/addEditProduct'

export const initialState: FlyOutMigrationProductsInfo = {
  migrationProducts: {
    products: {
      rows: [],
    },
  },
}

type actionType = {
  type: FlyoutMigrationProductsList.SET_FLYOUT_MIGRATION_PRODUCTS
  payload: FlyOutMigrationProducts
}

export const reducer: Reducer<FlyOutMigrationProductsInfo, actionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FlyoutMigrationProductsList.SET_FLYOUT_MIGRATION_PRODUCTS: {
      return {
        ...state,
        migrationProducts: action.payload,
      }
    }
    default: {
      return state
    }
  }
}
